<template>
    <div class="modal fade" id="createTaskModal" role="dialog" aria-labelledby="createTaskModallLabel" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="createTaskModalLabel">{{$t('tasks.task')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <details-card :model="model"
                                  :show="show" />
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('buttons.close')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Task } from '../../models/models';
    import moment from 'moment';
    import DetailsCard from './details.card';

    export default {
        components: {
            DetailsCard
        },
        props: {
            value: {},
            show: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                model: new Task(),
                moment: moment
            };
        },
        methods: {
            hide() {
                $(this.$el).modal('hide');
            },
            onClose() {
                this.$emit('onClose');
            }
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = new Task({ ...this.value });
                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px;
    }
</style>
